import React from 'react';

import Container from 'landing-page/components/common/Container';
import CopContent from 'landing-page/components/home/CoP/cop';
import SectionHeader from 'landing-page/components/home/SectionHeader';

const CoP: React.FC = () => {
    return (
        <Container>
            <SectionHeader
                title='Community of Practice (CoP)'
                subtitle='Menjadi Sumber Pengetahuan Terbaru'
                description='Forum diskusi rutin alumni LPDP untuk berbagi pengetahuan, menyusun solusi, dan memberi masukan kebijakan bagi kemajuan bangsa.'
                withTitleAnimation={true}
                withDescriptionAnimation={false}
                withLink={{
                    text: 'Lihat Lebih Lengkap',
                    url: '/cop'
                }}
                autoFetch={false}
                dataType='section_header_cop'
            />

            <CopContent autoFetch={true} />
        </Container>
    )
}


export default CoP;